"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var AnimateProgress = /*#__PURE__*/(0, _styledComponents.keyframes)(["0%{width:0}to{width:90%}"]);
var Bar = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "sc-1ly0uwc-0"
})(["background:", ";top:0;pointer-events:none;user-select:none;height:2px;z-index:20000000;position:fixed;left:0;width:0;opacity:1;contain:content;", ""], function (props) {
  return props.color;
}, function (props) {
  return props.active && (0, _styledComponents.css)(["transform:scaleX(1);transform-origin:left;animation:", " 2s cubic-bezier(0.65,0.05,0.36,1) forwards;will-change:transform;"], AnimateProgress);
});
var ProgressBar = function ProgressBar(props) {
  return /*#__PURE__*/_react["default"].createElement(Bar, props);
};
ProgressBar.propTypes = {
  /** Default color is z_red, you can override in in this prop */
  color: _propTypes["default"].string,
  /** If active, progress bar will start animating (on top of page and will stop at 90%) */
  active: _propTypes["default"].bool
};
ProgressBar.defaultProps = {
  color: _red["default"].z_red,
  active: false
};
var _default = exports["default"] = ProgressBar;